import { gql } from '@apollo/client';

export const AUTOMATICSTATETRANSITIONS_QUERY = gql`
  query Query($pager: PagerInputNew, $filters: AutomaticStateTransitionFilterInput) {
    automaticStateTransitions(pager: $pager, filters: $filters) {
      values {
        automaticStateTransitionId
        documentCode
        documentName
        documentTypeId
        fromStateCode
        fromStateId
        fromStateName
        inactive
      }
      total
    }
  }
`;

export const AUTOMATICSTATETRANSITION_QUERY = gql`
  query AutomaticStateTransition($automaticStateTransitionId: Int!) {
    automaticStateTransition(automaticStateTransitionId: $automaticStateTransitionId) {
      automaticStateTransitionId
      documentName
      documentTypeId
      fromStateId
      fromStateName
      inactive
      transitionRules {
        automaticStateTransitionId
        automaticStateTransitionRuleId
        formula
        orderNo
        toStateId
        toStateName
      }
    }
  }
`;

export const ACTIVE_DOCUMENT_TYPES = gql`
  query activeDocumentTypes {
    activeDocumentTypes {
      code
      id
      name
    }
  }
`;

export const DOCUMENT_TYPE_WITH_ALLOWED_STATES = gql`
  query documentTypeWithAllowedStates($documentTypeWithAllowedStatesId: Int!) {
    documentTypeWithAllowedStates(id: $documentTypeWithAllowedStatesId) {
      allowedStates {
        id
        documentStateId
        documentStateName
        documentStateCode
        documentColor
        commentIsMandatory
        isActive
        requestComment
        requestReason
        userGroups {
          documentAllowedStateId
          userGroupId
        }
      }
    }
  }
`;

export const AUTOMATIC_STATE_TRANSITIONS_FILTERS_QUERY = gql`
  {
    automaticStateTransitionListFilters @client {
      fullTextFilter {
        value
      }
      documentCode {
        value
      }
      documentName {
        value
      }
      fromStateCode {
        value
      }
      fromStateName {
        value
      }
      inactive {
        value
      }
    }
  }
`;
